import React from 'react';
import { Tooltip, Button } from '@douyinfe/semi-ui';
import { IconTerminal } from '@douyinfe/semi-icons';

class MaintanceModeButton extends React.Component {

    render() {
        return (
            <Tooltip content="Перейти в режим обслуживания" position="bottom">
                <Button className="maintance-button" theme="borderless" icon={<IconTerminal style={{color: '#fff'}}/>}/>
            </Tooltip>
        );
    }

}

export default MaintanceModeButton;